import { candidateInterviewConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

const user = JSON.parse(localStorage.getItem("jigsawUser"));

// create candidate
export const view_assigned_interview_kit_candidate_action =
  (jobApplicationId, interviewKitId) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.viewAssignedInterviewkitJob.replace(
          ":id",
          jobApplicationId
        )}${interviewKitId}/`
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.VIEW_ASSIGNED_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// get practice questions
export const get_practice_interview_question_details_candidate_action =
  (data) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS,
      payload: data,
    });
  };

// create candidate
export const get_assigned_interview_question_details_candidate_action =
  (id, page) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.getInterviewKitQuestions.replace(":id", id)}?page=${
          page ? page : 1
        }`
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.GET_PRACTICE_INTERVIEW_QUESTION_DETAILS_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// upload url candidate
export const get_mux_interview_video_upload_url_candidate_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.muxVideoUploadUrl}`
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_URL_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// asset play back id candidate
export const get_mux_interview_video_upload_playback_id_candidate_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.muxUploadAssetPlayBackId.replace(":id", id)}`
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.GET_MUX_INTERVIEW_VIDEO_UPLOAD_PLAYBACK_ID_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// create candidate
export const interview_video_upload_id_candidate_action =
  (data) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        `${config.candidate.candidateInterviewVideo}`,
        data
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.INTERVIEW_VIDEO_UPLOAD_ID_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// review interview kit candidate
export const review_interview_kit_candidate_action =
  (id, applicantId, page) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.candidateReviewInterview.replace(
          ":id",
          id
        )}${applicantId}/?page=${page ? page : 1}`
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.REVIEW_INTERVIEW_KIT_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// interview submit review candidate
export const interview_submit_request_get_candidate_action =
  (jobId, interviewId) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.submitRequestInterview.replace(
          ":id",
          jobId
        )}${interviewId}/`
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// interview submit review create candidate
export const interview_submit_request_create_candidate_action =
  (jobId, interviewId, data) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        `${config.candidate.submitRequestInterview.replace(
          ":id",
          jobId
        )}${interviewId}/`,
        data
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_CREATE_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Interview Submitted.");

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_GET_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage("Already Submitted.");
      return e;
    }
  };

// interview submit review create candidate
export const interview_submit_request_update_candidate_action =
  (jobId, interviewId, data) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.candidate.submitRequestInterview.replace(
          ":id",
          jobId
        )}${interviewId}/`,
        data
      );

      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Interview Requested.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.INTERVIEW_SUBMIT_REQUEST_UPDATE_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// interview submit review create candidate
export const get_recently_assigned_assessment_kits_list_candidate_action =
  () => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.recentlyAssignedAssessmentKits
      );
      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.GET_RECENTLY_ASSIGNED_ASSESSMENT_KITS_LIST_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// interview submit review create candidate
export const accept_assigned_assessment_kit_candidate_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.candidate.acceptAssessmentKit.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// interview submit review create candidate
export const accept_assigned_assessment_kit_details_candidate_action =
  (id) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.candidate.acceptAssessmentKitDetails.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.ACCEPT_ASSIGNED_ASSESSMENT_KIT_DETAILS_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

// interview submit review create candidate
export const get_jobs_linked_with_assigned_assessment_kit_candidate_action =
  (id, page) => async (dispatch) => {
    dispatch({
      type: candidateInterviewConstants.GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.candidate.getJobsLinkedWithAssignedAssessmentKit.replace(
          ":id",
          id
        )}?page=${page ? page : 1}`
      );
      if (response.status) {
        dispatch({
          type: candidateInterviewConstants.GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_SUCCESS,
          payload: response.data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: candidateInterviewConstants.GET_JOBS_LINKED_WITH_ASSIGNED_ASSESSMENT_KIT_CANDIDATE_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };
